import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  id: []
};

const replaceEmptyAdSlice = createSlice({
  name: 'replaceEmptyAd',
  initialState,
  reducers: {
    replaceEmptyAd: () => {},
    setEmptyAdID: (state, action) => ({ ...state, id: action.payload })
  }
});

export const { replaceEmptyAd, setEmptyAdID } = replaceEmptyAdSlice.actions;
export const useReplaceEmptyAdSliceSelector = createSelectorFn(replaceEmptyAdSlice);
export default replaceEmptyAdSlice;
